import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetRunLegLanesQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
  legs: Array<Types.Lanes_Bool_Exp> | Types.Lanes_Bool_Exp;
}>;


export type GetRunLegLanesQuery = { __typename?: 'query_root', lanes: Array<{ __typename?: 'lanes', id: number, origin_location_id: number, destination_location_id: number, distance_miles?: number | null, duration_sec?: number | null, route_polyline?: string | null, status?: string | null }> };


export const GetRunLegLanesDocument = gql`
    query getRunLegLanes($customerId: bigint!, $legs: [lanes_bool_exp!]!) {
  lanes(where: {customer_id: {_eq: $customerId}, _or: $legs}) {
    id
    origin_location_id
    destination_location_id
    distance_miles
    duration_sec
    route_polyline
    status
  }
}
    `;

/**
 * __useGetRunLegLanesQuery__
 *
 * To run a query within a React component, call `useGetRunLegLanesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRunLegLanesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRunLegLanesQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      legs: // value for 'legs'
 *   },
 * });
 */
export function useGetRunLegLanesQuery(baseOptions: Apollo.QueryHookOptions<GetRunLegLanesQuery, GetRunLegLanesQueryVariables> & ({ variables: GetRunLegLanesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRunLegLanesQuery, GetRunLegLanesQueryVariables>(GetRunLegLanesDocument, options);
      }
export function useGetRunLegLanesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRunLegLanesQuery, GetRunLegLanesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRunLegLanesQuery, GetRunLegLanesQueryVariables>(GetRunLegLanesDocument, options);
        }
// @ts-ignore
export function useGetRunLegLanesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRunLegLanesQuery, GetRunLegLanesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRunLegLanesQuery, GetRunLegLanesQueryVariables>;
export function useGetRunLegLanesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRunLegLanesQuery, GetRunLegLanesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRunLegLanesQuery | undefined, GetRunLegLanesQueryVariables>;
export function useGetRunLegLanesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRunLegLanesQuery, GetRunLegLanesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRunLegLanesQuery, GetRunLegLanesQueryVariables>(GetRunLegLanesDocument, options);
        }
export type GetRunLegLanesQueryHookResult = ReturnType<typeof useGetRunLegLanesQuery>;
export type GetRunLegLanesLazyQueryHookResult = ReturnType<typeof useGetRunLegLanesLazyQuery>;
export type GetRunLegLanesSuspenseQueryHookResult = ReturnType<typeof useGetRunLegLanesSuspenseQuery>;
export type GetRunLegLanesQueryResult = Apollo.QueryResult<GetRunLegLanesQuery, GetRunLegLanesQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/mobileService/queries/getRunLegLanes.query.gql}
 */
export async function getRunLegLanes(
  variables: GetRunLegLanesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetRunLegLanesQuery['lanes']>
export async function getRunLegLanes(
  variables: GetRunLegLanesQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetRunLegLanesQuery>
export async function getRunLegLanes(
  variables: GetRunLegLanesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetRunLegLanesQuery['lanes'] | GetRunLegLanesQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetRunLegLanesQuery>(
    GetRunLegLanesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.lanes
}